import { action } from './action'
import { batch } from './batch'
import { computed } from './computed'
import { debounce } from './debounce'
import { deep, deep as reactive } from './deep'
import { observe } from './observe'
import { ref } from './ref'
import { shallow } from './shallow'
import { throttle } from './throttle'
import { untrack } from './untrack'

import type { Annotations } from '../types'

export * from './action'
export * from './batch'
export * from './computed'
export * from './debounce'
export * from './deep'
export * from './ref'
export * from './shallow'
export * from './throttle'
export * from './untrack'

export const annotations: Annotations = {
  action,
  batch,
  computed,
  debounce,
  deep,
  observe,
  reactive,
  ref,
  shallow,
  throttle,
  untrack
}
